<template>
  <main id="main-content">
    <slot />
  </main>
  <!-- Global Footer -->
  <div>
    <div class="global-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="footer-copyright">
              <img class="logo" :src="getLogoSrc()" :alt="getLogoDescription()" />
              <span v-html="text"></span>
            </div>
          </div>
          <div class="col-lg-4">
            <ul class="navbar-nav ms-auto footer-links">
              <template v-for="(item, index) in navigationItems" :key="index">
                <li class="nav-item" v-if="item.subItems.length == 0">
                  <MyLink :to="item.url" class="nav-link" exact-active-class="active">
                    {{ item.title }}</MyLink
                  >
                </li>
                <li class="nav-item dropdown" v-if="item.subItems.length > 0">
                  <a
                    class="nav-link dropdown-toggle"
                    href="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    >{{ item.title }}
                    <font-awesome class="icon-caret" icon="chevron-down" />
                  </a>
                  <ul class="dropdown-menu">
                    <li v-for="subItem in item.subItems">
                      <MyLink
                        :external="true"
                        class="dropdown-item"
                        :to="subItem.url"
                        exact-active-class="active"
                      >
                        {{ subItem.title }}</MyLink
                      >
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CookieBanner />
</template>

<script setup lang="ts">
const showHeaderAndFooter = useState('showHeaderAndFooter')
const head = useLocaleHead({
  dir: true,
  lang: true,
  seo: true
})
useHead(() => ({
  htmlAttrs: head.value.htmlAttrs,
  meta: head.value.meta,
  link: head.value.link
}))
const siteStore = useSiteStore()
const navigationItems = siteStore.getFooterNavigationItems()

const siteCfg = siteStore.siteConfig
const logo = firstOrDefault(siteCfg.elements.websiteLogo.value)
const textOverwrite = ref(siteCfg.elements.footerTextOverwrite.value)
const text = computed(() => {
  if (textOverwrite.value) {
    return textOverwrite.value
  }

  return `&copy; ${new Date().getFullYear()} JND Legal Administration. All rights reserved.`
})
function getLogoSrc() {
  if (logo) {
    return logo?.url
  }

  return 'logo-jnd.png'
}

function getLogoDescription() {
  if (logo) {
    return logo.description || 'JND Logo'
  }

  return 'JND Logo'
}
</script>
